import { render, staticRenderFns } from "./MalattieInfettiveStruttureListComponent.vue?vue&type=template&id=798fbb4c"
import script from "./MalattieInfettiveStruttureListComponent.vue?vue&type=script&lang=js"
export * from "./MalattieInfettiveStruttureListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports